module.exports = __webpack_public_path__ + "static/phone-on-lap-81e74b009097f9a1d99a549750a17b59.jpg";